import React, { Suspense } from 'react';
import { Switch, Route, Redirect, Link } from 'react-router-dom';
import LoadingSpinner from './components/UI/LoadingSpinner';

const Home = React.lazy(() => import('./pages/Home'));
const LoginPage = React.lazy(() => import('./pages/Login'));
const Signup = React.lazy(() => import('./pages/Signup'));

function App() {
  return (
    <Suspense
      fallback={
        <div className='centered'><LoadingSpinner /></div>
      }
    >
      <Switch>
        <Route path='/' exact>
          <Redirect to='/home' />
        </Route>
        <Route path='/home' exact>
          <Home />
        </Route>
        <Route path='/login'>
          <LoginPage />
        </Route>
        <Route path='/signup'>
            <Signup />
        </Route>
        <Route path='*'>
          <div className='centered flex-col'>
            <p>Page Not Found!</p>
            <Link to='/home'>Back to Home</Link>
          </div>
        </Route>
      </Switch>
    </Suspense>
  );
}

export default App;
